import React from "react";
import NumberInput from "../../../../common/NumberInput";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { InputAdornment } from "@material-ui/core";

class Percent extends React.Component {
  render() {
    const {
      t,
      indicateur,
      sousRubriqueIndex,
      libelleEnglobantIndex,
      changeIndicateur,
      valueInputProps,
      computedFields,
      displayRules = null,
      valueAssolement = null,
    } = this.props;

    const valeurCalculee = (
      <NumberInput
        fullWidth={false}
        disabled
        InputProps={{
          ...valueInputProps,
          endAdornment: <InputAdornment position={"end"}>%</InputAdornment>,
        }}
        value={indicateur?.valeurCalculee?.value ?? ""}
        label={t("hve3a.valeur-mesparcelles", "Valeur MesParcelles")}
        style={{ maxWidth: "6rem" }}
        className={"mr-2"}
      />
    );

    const valeurAssolement = (
      <NumberInput
        size={this.props.size}
        disabled
        fullWidth={false}
        style={{ width: "8rem" }}
        label={"Valeur assolement"}
        value={valueAssolement ?? ""}
        InputProps={valueInputProps}
        className={"mr-2"}
      />
    );

    const valueRendered = (
      <NumberInput
        size={this.props.size}
        fullWidth={false}
        value={indicateur?.valeur?.value ?? ""}
        inputProps={{
          min: 0,
        }}
        InputProps={{
          endAdornment: <InputAdornment position={"end"}>%</InputAdornment>,
        }}
        disabled={computedFields.includes(indicateur?.codeNational)}
        style={{
          fontWeight: indicateur?.afficherGras ? "bold" : "normal",
          width: "8rem",
        }}
        onChange={(newValeur) =>
          changeIndicateur(
            { ...indicateur, valeur: { value: newValeur === "" ? null : Number(newValeur) } },
            sousRubriqueIndex,
            libelleEnglobantIndex
          )
        }
      />
    );

    return (
      <React.Fragment>
        {!!indicateur?.valeurCalculee && valeurCalculee}
        {!!displayRules?.displayAssolement && valeurAssolement}
        {valueRendered}
      </React.Fragment>
    );
  }
}

export default compose(withTranslation())(Percent);
